<template>
  <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
    <v-col cols="6">
      <v-row class="text-center" justify="space-between" height='90vh' style="margin: 0 0">
        <v-col cols='12'>
          <h1>{{credits}}</h1>
        </v-col>
      </v-row>
      <v-row class="text-center" justify="space-between" height='90vh' style="margin: 0 0">
        <v-col cols='2'>
          <v-btn fab color="red" @click="betValue--" :disabled="betValue == 1"><h1>-</h1></v-btn>
        </v-col>
        <v-col cols='2'>
          <h1>{{betValue}}</h1>
        </v-col>
        <v-col cols='2'>
          <v-btn fab color="blue" @click="betValue++" :disabled="betValue == 5"><h1>+</h1></v-btn>
        </v-col>
        <v-col cols='2'>
          <v-btn @click="draw">BET</v-btn>
        </v-col>
      </v-row>
      <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
        <v-expansion-panels accordion focusable>
          <v-expansion-panel>
            <v-expansion-panel-header>View Point Table</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>BET</th>
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th>5</th>
                  </tr>
                </thead>
                <tbody class="text-left">
                  <tr>
                    <th>2 Pair</th>
                    <td>2</td>
                    <td>4</td>
                    <td>6</td>
                    <td>8</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <th>3 of a Kind</th>
                    <td>3</td>
                    <td>6</td>
                    <td>9</td>
                    <td>12</td>
                    <td>18</td>
                  </tr>
                  <tr>
                    <th>Straight</th>
                    <td>4</td>
                    <td>8</td>
                    <td>12</td>
                    <td>16</td>
                    <td>20</td>
                  </tr>
                  <tr>
                    <th>Flush</th>
                    <td>5</td>
                    <td>10</td>
                    <td>15</td>
                    <td>20</td>
                    <td>25</td>
                  </tr>
                  <tr>
                    <th>Full House</th>
                    <td>10</td>
                    <td>20</td>
                    <td>30</td>
                    <td>40</td>
                    <td>50</td>
                  </tr>
                  <tr>
                    <th>4 of a Kind</th>
                    <td>25</td>
                    <td>50</td>
                    <td>75</td>
                    <td>100</td>
                    <td>125</td>
                  </tr>
                  <tr>
                    <th>Straight Flush</th>
                    <td>50</td>
                    <td>100</td>
                    <td>150</td>
                    <td>200</td>
                    <td>250</td>
                  </tr>
                  <tr>
                    <th>Royal Flush</th>
                    <td>250</td>
                    <td>500</td>
                    <td>750</td>
                    <td>1000</td>
                    <td>1250</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-col>
    <v-col cols="6">
        <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
          <v-col cols="12">
            <h1>{{handValue}}</h1>
          </v-col>
        </v-row>
        <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
        <v-col cols='2' v-for='card in hand'>
          <v-card class="px-2">
            <v-row class="text-start">
              <v-col cols="12">
                {{card.Value}}
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12">
                <v-icon v-if='card.Suit =="spades"' color="black">mdi-cards-spade</v-icon>
                <v-icon v-if='card.Suit =="diamonds"' color="red">mdi-cards-diamond</v-icon>
                <v-icon v-if='card.Suit =="clubs"' color="black">mdi-cards-club</v-icon>
                <v-icon v-if='card.Suit =="hearts"' color="red">mdi-cards-heart</v-icon>
              </v-col>
            </v-row>
            <v-row class="text-end">
              <v-col cols='12'>
                {{card.Value}}
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'poker',
    data: () => ({
      suits: ["spades", "diamonds", "clubs", "hearts"],
      values: ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"],
      deck: [],
      hand: [],
      handValue: "",
      betValue: 1,
      credits: 100,
    }),
    methods: {
      createDeck(suits, values){
        var deck = new Array();

        for(var i = 0; i < suits.length; i++)
        {
          for(var x = 0; x < values.length; x++)
          {
            var card = {Value: values[x], Suit: suits[i]};
            deck.push(card);
          }
        }
      
        return deck;
      },
      shuffle(array){
        var currentIndex = array.length, temporaryValue, randomIndex;

        while (0 !== currentIndex) {
      
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
      
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
      
        return array;
      },
      draw(){
        var deck = this.shuffle(this.createDeck(this.suits, this.values));
        var hand = new Array();
        var handSuits = new Array();
        var handValues = new Array();
        var handValue = 'None'
        for(var i = 0; i < 5; i++){
          hand.push(deck[i]);
          handSuits.push(deck[i].Suit);
          handValues.push(deck[i].Value);
        }
        this.hand = hand;
        handValues = ['2', '2', 'K', 'K', 'K'];
        handValues = this.replaceFaces(handValues);
        console.log(handValues);
        if(this.fullHouse(handValues)){
          handValue = "Full House";
          this.credits += (this.betValue * 10);
        }
        if(this.twoPair(handValues)){
          handValue = "Two Pair";
          this.credits += (this.betValue * 2);
        }
        if(this.threeOfAKind(handValues)){
          handValue = "Three of a Kind";
          this.credits += (this.betValue * 3);
        }
        if(this.straight(handValues)){
          handValue = "Straight";
          this.credits += (this.betValue * 4);
        }
        if(handSuits.every(suit => suit === handSuits[0])){
          handValue = "Flush";
          this.credits += (this.betValue * 5);
        }
        this.handValue = handValue;
        this.credits -= this.betValue;
      },
      twoPair(handValues){
        var numberOfPairs = 0;
        //CHECK FOR TWO PAIR
        for(var i = 0; i < handValues.length - 1; i++){
          if(handValues[i] === handValues[i + 1]){
            numberOfPairs++;
            handValues.splice((i + 1), 1);
          }
        }
        if(numberOfPairs == 2){
          return true;
        } else {
          return false
        }
      },
      threeOfAKind(handValues){
        for(var i = 0; i < 3; i++){
          if(handValues[i] === handValues[i + 1] && handValues[i] === handValues[i + 2]){
            return true;
          }
        }
        return false;
      },
      straight(handValues){
        for(var i = 0; i < 4; i++){
          if(handValues[i] != (handValues[i + 1] - 1)){
            return false;
          }
        }
        return true;
      },
      fullHouse(handValues){
        if(handValues[0] == handValues[1] && handValues[0] == handValues[2] && handValues[3] == handValues[4]){
          console.log('FULL HOUSE');
          return true;
        }
        if(handValues[0] == handValues[1] && handValues[2] == handValues[3] && handValues[2] == handValues[4]){
          console.log('FULL HOUSE');
          return true;
        }
        return false;
      },
      replaceFaces(handValues){
        let index = 0;
        for(var i = 0; i < 5; i++){
          if(handValues[i] == "J"){
            handValues[i] = "11";
          }
          if(handValues[i] == "Q"){
            handValues[i] = "12";
          }
          if(handValues[i] == "K"){
            handValues[i] = "13";
          }
        }
        if(handValues.includes("A")){
          for(var i = 0; i < 5; i++){
            if(handValues[i] == "A"){
              if(handValues.includes("13")){
                handValues[i] = "14";
              } else {
                handValues[i] = "1";
              }
            }
          }
        }
        return handValues.sort(function(a, b){return a-b});
      },
    },
    beforeMount(){
      this.deck = this.shuffle(this.createDeck(this.suits, this.values));
    }
  }
</script>

<style>
  th, td{
    border: none !important;
    border-bottom: 1px solid grey !important;
  }
</style>